import APIClient from '../../../common/APIClient';
import { toggleShowAlert, displayError, SUCCESS_ALERT, ERROR_ALERT, MAX_ITEMS_IN_PAGE } from '../commonActions';
import qs from 'qs';
import { Cache } from 'aws-amplify';
import moment from 'moment';

const FETCH_PLATFORMS = 'FETCH_PLATFORMS';
const SET_BAND_FIELD_CHANGE = 'SET_BAND_FIELD_CHANGE';
const SET_FL_BAND_COST_FIELD_CHANGE = 'SET_FL_BAND_COST_FIELD_CHANGE';
const SET_UL_BAND_COST_FIELD_CHANGE = 'SET_UL_BAND_COST_FIELD_CHANGE';
const SET_PLATFORM_FIELD_CHANGE = 'SET_PLATFORM_FIELD_CHANGE';
const SET_PLATFORM = 'SET_PLATFORM';
const RESET_PLATFORM = 'RESET_PLATFORM';
const SET_PLATFORM_BANDS = 'SET_PLATFORM_BANDS';
const PLATFORM_FILTER = 'PLATFORM_FILTER';

export const SET_PLATFORMS_PAGINATION = 'SET_PLATFORMS_PAGINATION';
export const RESET_PLATFORMS_PAGINATION = 'RESET_PLATFORMS_PAGINATION';
export const SET_PROJECT_PLATFORMS_BANDS = 'SET_PROJECT_PLATFORMS_BANDS';
export const SET_PROJECT_PLATFORMS = 'SET_PROJECT_PLATFORMS';

export const FULLY_LOADED = 'fully-loaded';
export const UNLOADED = 'unloaded';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchPlatforms = (filters = null, forProjectForm = false) => {
  let params = {}

  if (filters && Object.keys(filters).length) {
    Object.assign(params, {filters})
  }
  return (dispatch, getState) => {
    client().get(
      'platform/list', {
        params, 
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let platforms = result.data;
        if (!platforms.length) {
          platforms = null;
        }
        else {
          let numItems = platforms.length;
          let min = getState().platforms.min;
          let max = numItems < MAX_ITEMS_IN_PAGE ? numItems : getState().platforms.max;
          
          const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);
          
          dispatch({type: SET_PLATFORMS_PAGINATION, numItems, min, max, totalPages});
        }

        if (!forProjectForm) {
          dispatch({type: FETCH_PLATFORMS, platforms});
        }
        else {
          dispatch({type: SET_PROJECT_PLATFORMS, projPlatforms: platforms});
        }
      }
    }).catch(error => {
      dispatch(displayError(error))
    })
  }
}

export const getPlatform = (platformId, successCallback, errorCallback) => {
  return (dispatch) => {
    client().get(
      'platform/get', {
        params: {
          platform_id: platformId
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let platform = result.data;
        if (platform) {
          dispatch({type: SET_PLATFORM, platform});
          dispatch(fetchPlatformBands({platform_id: platformId, year: moment().year()}));
          if (successCallback) {
            successCallback();
          }
        }
        else {
          dispatch(toggleShowAlert(true, ERROR_ALERT, "Platform doesn't exists."));
          if (errorCallback) {
            errorCallback();
          }
        } 
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const fetchPlatformBands = (filters = null, forProjectForm = false, callback = null) => {
  let params = {}

  if (filters && Object.keys(filters).length) {
    Object.assign(params, {filters});
  }

  return (dispatch, getState) => {
    let platform = getState().platforms.platform;
    
    client().get(
      'platform/band/list', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let platformBands = result.data;
        let objFullyLoadedBands = {} //fully loaded bands
        let objUnloadedBands = {} //unloaded bands
        let year = '';
        //construct the platform bands as object {[band_id]: [cost]}
        if (platformBands.length) {
          platformBands.forEach(platformBand => {
            if (platformBand.fully_loaded) {
              Object.assign(objFullyLoadedBands, {[platformBand.band_id]: platformBand.cost});
            }
            else {
              Object.assign(objUnloadedBands, {[platformBand.band_id]: platformBand.cost});
            }
            year = platformBand.year;
          })
        }
        else {
          platformBands = null;
          if (filters.year !== "undefined") {
            year = filters.year;
          }
        }

        Object.assign(platform, {year});
        dispatch({type: SET_PLATFORM, platform});

        if (!forProjectForm) {
          dispatch({type: SET_PLATFORM_BANDS, 
            fullyLoadedBands: objFullyLoadedBands, 
            unloadedBands: objUnloadedBands, 
            arrPlatformBands: platformBands});
        }
        else {
          dispatch({type: SET_PROJECT_PLATFORMS_BANDS, projPlatformBands: platformBands});
        }

        if (callback) {
          callback();
        }
      }
    }).catch(error => {
      dispatch(displayError(error))
    })
  }
}

export const resetPlatform = () => {
  return (dispatch) => {
    dispatch({type: RESET_PLATFORM});
  }
}

export const handleInputChange = (e, definedValue = null) => {
  let actionType = '';
  let value = {}
  if (!definedValue) {
    const id = e.target.id;
  
    value = {
      [id]: e.target.value
    }

    if (id === "platform_name" || id === "chargeability") {
      actionType = SET_PLATFORM_FIELD_CHANGE;
    }
    else {
      actionType = SET_BAND_FIELD_CHANGE;
    }
  }
  else {
    value = definedValue;
    actionType = SET_PLATFORM_FIELD_CHANGE;
  }

  return (dispatch) => {
    dispatch({type: actionType, value})
  }
}

export const handleBandCostChange = (e, costingType) => {
  return (dispatch) => {
    const value = {
      [e.target.id]: e.target.value
    }

    let dispatchType = costingType === FULLY_LOADED ? SET_FL_BAND_COST_FIELD_CHANGE : SET_UL_BAND_COST_FIELD_CHANGE;

    dispatch({type: dispatchType, value})
  }
}

export const createPlatform = (successCallback = null) => {
  return (dispatch, getState) => {
    const platform = getState().platforms.platform;
    const fullyLoadedBands = getState().platforms.fullyLoadedBands;
    const unloadedBands = getState().platforms.unloadedBands;
    
    client().post(
      'platform/create', 
      platform 
    ).then(json => {
      const result = json.data;
      if (result) {
        //save platform bands
        if (Object.keys(fullyLoadedBands).length || Object.keys(unloadedBands).length) {
          const totalBands = Object.keys(fullyLoadedBands).length + Object.keys(unloadedBands).length;
          Cache.setItem('numBands', totalBands);
          const platformId = result.data;
          if (platformId) {
            let allPlatformBands = [];
            for (const [bandId, cost] of Object.entries(fullyLoadedBands)) {
              if (bandId && cost) {
                allPlatformBands.push({
                  platform_id: platformId, 
                  band_id: bandId, 
                  cost, 
                  fully_loaded: 1, 
                  year: platform.year
                })
              }
              
            } 

            for (const [bandId, cost] of Object.entries(unloadedBands)) {
              if (bandId && cost) {
                allPlatformBands.push({
                  platform_id: platformId, 
                  band_id: bandId, 
                  cost, 
                  fully_loaded: 0, 
                  year: platform.year
                })
              }
            } 

            allPlatformBands.length && allPlatformBands.forEach(objBandParam => {
              client().post(
                'platform/band/create', 
                objBandParam
              ).then(json => {
                const result = json.data;
                if (result) {
                  let numBands = Cache.getItem('numBands');
                  
                  numBands--;
                  if (numBands === 0) {
                    dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Platform has been successfully created."));
                    Cache.removeItem('numBands');
                  }
                  else {
                    Cache.setItem('numBands', numBands);
                  }
                }
              }).catch(error => {
                dispatch(displayError(error));
              })
            })
            
            if (successCallback) {
              successCallback();
            }
          }
        }
        else {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Platform has been successfully added."));

          if (successCallback) {
            successCallback();
          }
        }
      }
    }).catch(error => {
      dispatch(displayError(error))
    })
  }
}

export const updatePlatform = (successCallback = null) => {
  return (dispatch, getState) => {
    const platform = getState().platforms.platform;
    const fullyLoadedBands = getState().platforms.fullyLoadedBands; //object of bands {band_id: cost}
    const unloadedBands = getState().platforms.unloadedBands;

    client().post(
      'platform/update', 
      platform
    ).then(json => {
      const result = json.data;
      if (result) {
        const totalBands = Object.keys(fullyLoadedBands).length + Object.keys(unloadedBands).length;
        Cache.setItem('numBands', totalBands);

        //upsert fully loaded band cost 
        for (const [bandId, cost] of Object.entries(fullyLoadedBands)) {
          dispatch(upsertBandCost(cost, bandId, true, successCallback));
        }

        //upsert unloaded band cost 
        for (const [bandId, cost] of Object.entries(unloadedBands)) {
          dispatch(upsertBandCost(cost, bandId, false, successCallback));
        }
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const deletePlatform = (platformId) => {
  return (dispatch) => {
    client().get(
      'platform/delete', {
        params: {
          id: platformId
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Platform has been successfully deleted."));
        dispatch(fetchPlatforms());
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const filterPlatforms = (filter) => {
  return (dispatch) => {
    dispatch({type: PLATFORM_FILTER, filter});
  }
}

const upsertBandCost = (cost, bandId, isFullyLoaded, successCallback) => {
  return (dispatch, getState) => {
    isFullyLoaded = isFullyLoaded ? 1 : 0;

    const platform = getState().platforms.platform;
    const arrPlatformBands = getState().platforms.arrPlatformBands;
    //get the ID of the band entry in arrPlatformBands
    let platformBandId = '';
    arrPlatformBands && arrPlatformBands.length && arrPlatformBands.filter(data => {
      if (data.band_id === parseInt(bandId) 
        && data.platform_id === parseInt(platform.id) 
        && data.fully_loaded === isFullyLoaded) {
        return data;
      }
      return false;
    }).forEach(platformBand => {
      platformBandId = platformBand.id;
    })

    //if no platform_b and_id, it's a new platform band
    if (platformBandId) {
      client().post(
        'platform/band/update', {
          id: platformBandId, 
          band_id: bandId, 
          platform_id: platform.id, 
          cost: cost,
          fully_loaded: isFullyLoaded, 
          year: platform.year 
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          let numBands = Cache.getItem('numBands');

          numBands--;
          if (numBands === 0) {
            dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Platform has been successfully updated."));
            Cache.removeItem('numBands');

            if (successCallback) {
              successCallback();
            }
          }
          else {
            Cache.setItem('numBands', numBands);
          }
        }
      }).catch(error => {
        dispatch(displayError(error))
      })
    }
    else {
      client().post(
        'platform/band/create', {
          platform_id: platform.id, 
          band_id: bandId, 
          cost: cost,
          fully_loaded: isFullyLoaded, 
          year: platform.year
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          let numBands = Cache.getItem('numBands');

          numBands--;
          if (numBands === 0) {
            dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Platform has been successfully updated."));
            Cache.removeItem('numBands');
            if (successCallback) {
              successCallback();
            }
          }
          else {
            Cache.setItem('numBands', numBands);
          }
        }
      }).catch(error => {
        dispatch(displayError(error));
      })
    }
  }
}